import { moduleName as recordModuleName } from "../../../records";
import { vsModuleName as shareMachineModuleName } from "../../shared";
import angular from "angular";
import { vsModuleName as shareContractModuleName } from "../../../Contract/shared";
import { machineConfigurationConfig } from "./machine";
import { vsModuleName as changeJournalConfigModule } from "./changeJournal/module";
import { vsModuleName as lookupConfigModuleName } from "./lookup/module";
import {
  MachineDetailTabsProvider,
  vsServiceName as MachineDetailTabsServiceName,
} from "../../shared/components/views/machines/detail/tabs";
export const vsModuleName = "SlotTrak.Machines.Config";

const module = angular
  .module(vsModuleName, [
    recordModuleName,
    //shareMachineModuleName,
    shareContractModuleName,
    changeJournalConfigModule,
    lookupConfigModuleName,
  ])
  .config(machineConfigurationConfig)
  .provider(MachineDetailTabsServiceName, MachineDetailTabsProvider);
